import UIComponent from '../../common/UIComponent';
import './index.css';
import DanmakuSetting from '../danmakuSetting/index.js';
export default class Barrage extends UIComponent {
  constructor(elementId, interfaces) {
    super(interfaces);
    this.elementId = elementId;
    this.interfaces = interfaces;
    this.init();
  }

  init() {
    // 创建弹幕控制组件
    this.barrageControl = document.createElement('div');
    this.barrageControl.setAttribute('class', 'vhallPlayer-brarage-component');
    this.barrageControl.onmouseleave = this.handleComponentMouseLeave.bind(this);

    // 创建弹幕控制小图标
    this.barrageBtn = document.createElement('span');
    this.barrageBtn.setAttribute('class', 'vhallPlayer-brarage-btn vh-player-iconfont vh-player-line-player-barrageon');
    this.barrageBtn.onclick = this.handleBtnClick.bind(this);
    this.barrageBtn.onmouseenter = this.handleVolumeBtnEnter.bind(this);

    // 创建 “弹幕设置弹窗” 的父容器
    this.danmakuSettingPopup = document.createElement('div');
    this.danmakuSettingPopup.setAttribute('class', 'vhallPlayer-brarage-popup');

    this.barrageControl.appendChild(this.barrageBtn);
    this.barrageControl.appendChild(this.danmakuSettingPopup);
    this.insertElement(this.elementId, this.barrageControl);
    // 初始化 “弹幕设置弹窗”
    new DanmakuSetting(this.danmakuSettingPopup, this.interfaces);
  }

  handleVolumeBtnEnter() {
    if (this.barrageBtn.classList.contains('vh-player-line-player-barrageon')) {
      this.danmakuSettingPopup.style.display = 'block';
    }
  }

  handleComponentMouseLeave() {
    this.danmakuSettingPopup.style.display = 'none';
  }

  handleBtnClick() {
    if (this.barrageBtn.classList.contains('vh-player-line-player-barrageoff')) {
      this.barrageBtn.classList.add('vh-player-line-player-barrageon');
      this.barrageBtn.classList.remove('vh-player-line-player-barrageoff');
      this.interfaces.openBarrage();
      this.danmakuSettingPopup.style.display = 'block';
    } else {
      this.barrageBtn.classList.remove('vh-player-line-player-barrageon');
      this.barrageBtn.classList.add('vh-player-line-player-barrageoff');
      this.interfaces.closeBarrage();
      this.danmakuSettingPopup.style.display = 'none';
    }
  }
}
